import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, {Component} from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { motion, useCycle } from "framer-motion"
import headerStyles from "./mobileHeader.module.css"
import Celebration from "./celebration.js"
import logo from "../images/brand/Logo/Secondary/Small/PNG/Secondary Logo - Small.png";
import nycBrain from "../images/brand/Illustrations/Brain/Small/PNG/Statue of Liberty-Small.png"
import celebrateBrain from "../images/brand/Illustrations/Brain/Small/PNG/Celebrate-Small.png"
import glassesBrain from "../images/brand/Illustrations/Brain/Small/PNG/Glasses-Small.png"
import laptopBrain from "../images/brand/Illustrations/Brain/Small/PNG/Laptop Sleeping2-Small.png"
import loveBrain from "../images/brand/Illustrations/Brain/Small/PNG/Love-Small.png"
import mindBlownBrain from "../images/brand/Illustrations/Brain/Small/PNG/Mindblown-Small.png"
import meditateBrain from "../images/brand/Illustrations/Brain/Small/PNG/Meditate-Small.png"
import readingBrain from "../images/brand/Illustrations/Brain/Small/PNG/Reading-Small.png"
import skateboardBrain from "../images/brand/Illustrations/Brain/Small/PNG/Skateboard-Small.png"
import starryEyeBrain from "../images/brand/Illustrations/Brain/Small/PNG/Starry eyed-Small.png"
import flagBrain from "../images/brand/Illustrations/Brain/Small/PNG/Waving Flag-Small.png"

const brains = [nycBrain, celebrateBrain, glassesBrain, laptopBrain, loveBrain, mindBlownBrain, meditateBrain, readingBrain, skateboardBrain, starryEyeBrain, flagBrain]

const Path = props => (
  <motion.path
    fill="transparent"
    strokeWidth="2"
    stroke="var(--color-Black-Jeans-66p)"
    strokeLinecap="round"
    {...props}
  />
);

export const MenuToggle = ({ toggle }) => (
  <button onClick={toggle} style={{width:"40px", height:"40px"}}>
    <svg viewBox="0 0 23 23">
      <Path
        variants={{
          closed: { d: "M 0 2.5 L 23 2.5" },
          open: { d: "M 3 16.5 L 17 2.5" }
        }}
      />
      <Path
        d="M 0 9.423 L 23 9.423"
        variants={{
          closed: { opacity: 1 },
          open: { opacity: 0 }
        }}
        transition={{ duration: 0.1 }}
      />
      <Path
        variants={{
          closed: { d: "M 0 16.346 L 23 16.346" },
          open: { d: "M 3 2.5 L 17 16.346" }
        }}
      />
    </svg>
  </button>
);

const menuVariants = {
    open: {
        height:"100vh",
        transition: {
          type: "spring",
          restDelta: 2
        }
    },
    closed: {
        height:"0",
        transition: {
          delay: 0.5,
          type: "spring",
          damping: 15
        }
    },
}


const listVariants = {
  open: {
    pointerEvents: 'all',
    transition: { staggerChildren: 0.07, delayChildren: 0.2 }
  },
  closed: {
    pointerEvents: 'none',
    transition: { staggerChildren: 0.05, staggerDirection: -1 }
  }
};

const listItemVariants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 }
    }
  }
};

export const BlackMenuItem = ({ link, location }) => {
  return (
    <motion.li
      variants={listItemVariants}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <Link to={location} style={{color:"black"}}>{link}</Link>
    </motion.li>
  );
};

export const BlackAMenuItem = ({ link, location }) => {
  return (
    <motion.li
      variants={listItemVariants}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <a href={location} target="_blank" style={{color:"black"}}>{link}</a>
    </motion.li>
  );
};

export const OrangeMenuItem = ({ link, location }) => {
  return (
    <motion.li
      variants={listItemVariants}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <Link to={location} style={{color:"var(--color-Orange-AF)"}}>{link}</Link>
    </motion.li>
  );
};


class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            brain: brains[Math.floor(Math.random() * brains.length)]
        }

        this.headerRef = React.createRef();
        this.boxShadowFunction = () => {
            window.requestAnimationFrame(() => {
                if (this.headerRef && this.headerRef.current) {
                    if (window.pageYOffset != 0) {
                        this.headerRef.current.style.boxShadow = "0 4px 4px rgba(0, 0, 0, 0.1)";
                    } else {
                        this.headerRef.current.style.boxShadow = "none";
                    }
                }
            })
        }
    }

    toggleOpen() {
        this.setState({isOpen: !this.state.isOpen});
    }

    componentDidMount() {
        document.addEventListener('scroll', this.boxShadowFunction);
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.boxShadowFunction);
    }

    render() {
        return (
            <>
                <div ref={this.headerRef} className={headerStyles.headerWrapper}>
                    <header>
                        <div style={{display:"grid", gridTemplateColumns: "1fr 1fr"}}>
                            <div style={{textAlign:"left"}}>
                                <Link to="/">
                                    <img src={logo} style={{width:"75px", marginTop:"-15px", marginBottom:"-10px"}}/>
                                </Link>
                            </div>
                            <motion.div initial={false} animate={this.state.isOpen ? "open" : "closed"} className={headerStyles.toggle} style={{width:"40px", height:"40px", marginLeft:"auto", marginRight:"0", marginTop:"5px"}}>
                                <MenuToggle toggle={() => this.toggleOpen()} />
                            </motion.div>
                        </div>
                    </header>
                </div>
                <motion.div className={headerStyles.mobileNav} initial={false} animate={this.state.isOpen ? "open" : "closed"} variants={menuVariants} style={{position:"fixed", width:"100%", maxWidth:"600px", top:"64px", right:"0", zIndex:"10", marginTop:"-1px", backgroundColor:"white"}}>
                    <motion.ul variants={listVariants}>
                      <motion.li variants={listItemVariants}>
                        <img src={this.state.brain} style={{width: "150px", margin:"-40px 0 -10px"}}/>
                      </motion.li>
                      <div onClick={() => {if (!this.props.location) { this.toggleOpen() }}}>
                        <BlackMenuItem link="Home" location="/" key={0}/>
                      </div>
                      <div onClick={() => {if (this.props.location === "/about") { this.toggleOpen() }}}>
                        <BlackMenuItem link="About Us" location="/about" key={1}/>
                      </div>
                      <BlackAMenuItem link="Merch" location="https://www.bonfire.com/store/almost-fun/" key={2}/>
                      <BlackAMenuItem link="Donate" location="https://secure.givelively.org/donate/almost-fun-inc" key={3}/>
                      <div onClick={() => {if (this.props.location === "/for-teachers") { this.toggleOpen() }}}>
                        <BlackMenuItem link="For Teachers" location="/for-teachers" key={4}/>
                      </div>
                      <div onClick={() => {if (this.props.location === "/lessons") { this.toggleOpen() }}}>
                        <OrangeMenuItem link="Math Lessons" location="/lessons" key={5}/>
                      </div>
                        <OrangeMenuItem link="SAT Prep" location="/app/login" key={6}/>
                      <div onClick={() => {if (this.props.location === "/guides") { this.toggleOpen() }}}>
                        <OrangeMenuItem link="Blog" location="/guides" key={7}/>
                      </div>
                    </motion.ul>
                </motion.div>
            </>
        )
    }
}

export default Header;
